import React from 'react';
import PropTypes from 'prop-types';

import { BOLD_DEFINITIONS } from '@xingternal/content-editor-plugin-helpers';

import { BOLD_TAG_NAME } from './constants';

const renderer = ({
  node: { type },
  BOLD_TAG = BOLD_TAG_NAME,
  ...attributes
}) => {
  if (type === BOLD_DEFINITIONS.type) {
    const {
      nodeAttributes: { children },
      renderers,
      ...restOfAttributes
    } = attributes;

    return <BOLD_TAG {...restOfAttributes}>{children}</BOLD_TAG>;
  }
};

renderer.propTypes = {
  BOLD_TAG: PropTypes.node,
  text: PropTypes.string,
};

export { renderer };
